export default __webpack_public_path__ + "static/media/work-learn.pastry-arts.89734690.png";